import { render, staticRenderFns } from "./BurgerButton.vue?vue&type=template&id=7096bdf7&scoped=true&"
import script from "./BurgerButton.vue?vue&type=script&lang=js&"
export * from "./BurgerButton.vue?vue&type=script&lang=js&"
import style0 from "./BurgerButton.vue?vue&type=style&index=0&id=7096bdf7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7096bdf7",
  null
  
)

export default component.exports